import { ITagsData } from "src/api/server/extended-search.types";
import { ITagValue } from "../components/types";
import { SearchQueryParams } from "../search.types";

export const mapTagsFromQuery = (urlParams: URLSearchParams, tagsData: ITagsData): ITagValue[] => {
    const selectedTags = urlParams.get(SearchQueryParams.Tags)?.split(",") ?? [];
    const allTags = [
        ...tagsData.tags.basics.tags,
        ...tagsData.tags.rewards.tags,
        ...tagsData.tags.tradings.tags,
        ...tagsData.tags.investmentHorizon.tags,
        ...tagsData.tags.investmentRegion.tags,
        ...tagsData.tags.alphaBeta.tags,
    ];

    return allTags.flatMap(filterTag =>
        selectedTags.includes(filterTag.urlIdentifier)
            ? [
                  {
                      value: filterTag.urlIdentifier,
                      isPopular: filterTag.isPopular ?? false,
                  },
              ]
            : []
    );
};

export const mapTagsToQuery = (tags: readonly ITagValue[]) => {
    return tags && tags.length > 0 ? `${SearchQueryParams.Tags}=${tags.map(tag => tag.value).join(",")}` : "";
};
